import type { ProdStatsType } from "./run-container";

export type ProdStatsTab =
  | "Cycle Chart"
  | "Polony Density Flow Cell"
  | "Cycle Data Flow Cell"
  | "Indexing Stats"
  | "Values Log";

type TabGateInput = {
  tab: ProdStatsTab;
  prodStatsExists: boolean;
  data: ProdStatsType | undefined;
  isLoading: boolean;
  isVitari: boolean;
};

/**
 * Whether a ProdStats tab in the run display dropdown is disabled. Non-Vitari runs keep today's
 * rule (`!data`, and `!prodStatsExists` for Values Log). A Vitari run only has the Polony Density
 * payload (SW-29917), so each tab is enabled only when its own payload is present.
 */
export function prodStatsTabDisabled({
  tab,
  prodStatsExists,
  data,
  isVitari,
}: TabGateInput): boolean {
  if (!isVitari) {
    return tab === "Values Log" ? !prodStatsExists : !data;
  }

  switch (tab) {
    case "Polony Density Flow Cell":
      return !((data?.tiles?.tileLabels?.length ?? 0) > 0);
    case "Cycle Chart":
      return !data?.avgQByCycle;
    case "Cycle Data Flow Cell":
      return !data?.tiles?.avgQByCycle;
    case "Indexing Stats":
      return !((data?.indexingRunStats?.NumPolonies ?? 0) > 0);
    case "Values Log":
      return true;
  }
}

export function prodStatsTabSuffix(
  input: TabGateInput
): "" | " (unavailable)" | " (loading...)" {
  if (input.tab === "Values Log") {
    return !input.prodStatsExists || input.isVitari ? " (unavailable)" : "";
  }
  if (!input.prodStatsExists) return " (unavailable)";
  if (input.isLoading) return " (loading...)";
  if (input.isVitari && prodStatsTabDisabled(input)) return " (unavailable)";
  return "";
}
